import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseArticles() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faTitle: isEmpty(state.faTitle),
      enTitle: isEmpty(state.enTitle),
      articleType: isEmpty(state.articleType),
      groupID: isEmpty(state.groupID),
      authorID: isEmpty(state.authorID),
      content: isEmpty(state.content),
      contentSum: isEmpty(state.contentSum),
    };

    setter(errorState);

    if (
      errorState.faTitle ||
      errorState.enTitle ||
      errorState.articleType ||
      errorState.groupID ||
      errorState.authorID ||
      errorState.content ||
      errorState.contentSum
    ) {
      enqueueSnackbar("لطفا اطلاعات مقاله را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetArticles = (search, myPC, bool, callback) => {
    MyAxios.get(`Admin_Articles?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetAuthors = (callback) => {
    let myPC = {
      PageCount: 1,
    };
    MyAxios.get(`Admin_Authors?w=`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetArticleGroups = (callback) => {
    let myPC = {
      PageCount: 1,
    };
    MyAxios.get(`Admin_ArticleGroups?w=`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetArticleByID = (ArticleID, callback) => {
    MyAxios.get(`Admin_Articles/${ArticleID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddArticle = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Articles`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateArticle = (Model, callback) => {
    Model = removeObg(Model);
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.put(`Admin_Articles`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticle = (ArticleID, callback) => {
    const data = new FormData();
    data.append("ArticleID", ArticleID);
    MyAxios.delete(`Admin_Articles`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("حذف مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddArticleResource = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Articles/Resource`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticleResource = (ResourceID, callback) => {
    const data = new FormData();
    data.append("ResourceID", ResourceID);
    MyAxios.delete(`Admin_Articles/Resource`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const GetArticleAssistant = (callback) => {
    MyAxios.get(`Admin_Articles/Assistant`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddArticleAssistant = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Articles/Assistant`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticleAssistant = (AuthorID, callback) => {
    const data = new FormData();
    data.append("AuthorID", AuthorID);
    MyAxios.delete(`Admin_Articles/Assistant`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف کمک نویسنده باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const GetArticleImages = (ArticleID, callback) => {
    MyAxios.get(`Admin_Articles/Image/${ArticleID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddArticleImage = (Model, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    data.append("Image", file);
    MyAxios.post(`Admin_Articles/Image`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن تصویر مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticleImage = (ImageID, callback) => {
    const data = new FormData();
    data.append("ImageID", ImageID);
    MyAxios.delete(`Admin_Articles/Image`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("حذف تصویر مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const GetAllAdvs = (callback) => {
    MyAxios.get(`Admin_Articles/adv`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const GetArticleAdvs = (ArticleID, callback) => {
    MyAxios.get(`Admin_Articles/adv/${ArticleID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const EditArticleAdv = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ArticleGroups/adv`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddArticleAdv = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Articles/adv`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن تبلیغ مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticleAdv = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_Articles/adv`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("حذف تبلیغ مقاله باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const GetArticleProducts = (ArticleID, callback) => {
    MyAxios.get(`Admin_Articles/product/${ArticleID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const EditArticleProduct = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Articles/product`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddArticleProduct = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_Articles/product`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن محصول مرتبط باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteArticleProduct = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_Articles/product`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف محصول مرتبط باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const ResetCache = (id, callback) => {
    MyAxios.get(`Admin_Articles/ResetCache/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کش با موفقیت به‌روزرسانی شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const removeObg = (product) => {
    delete product.shamsiLogdate;
    delete product.authorAssistant;
    delete product.resources;
    delete product.author;
    delete product.visit;
    delete product.group;
    return product;
  };

  return {
    GetArticles,
    GetArticleByID,
    validate,
    AddArticle,
    UpdateArticle,
    DeleteArticle,
    GetArticleImages,
    AddArticleImage,
    DeleteArticleImage,
    GetArticleAssistant,
    DeleteArticleAssistant,
    AddArticleAssistant,
    AddArticleResource,
    DeleteArticleResource,
    GetAuthors,
    GetArticleGroups,
    GetAllAdvs,
    GetArticleAdvs,
    AddArticleAdv,
    DeleteArticleAdv,
    EditArticleAdv,
    ResetCache,
    GetArticleProducts,
    EditArticleProduct,
    AddArticleProduct,
    DeleteArticleProduct,
  };
}
